import React from 'react'
import { PublicCompetitionInfo } from 'components'

const PublicCompetition = ({
  isPublicCompetition,
  auctionInfo,
  video,
  document,
}) => {
  const isVisibleSection = isPublicCompetition && auctionInfo[0]

  if (!isVisibleSection) return null

  return (
    <section>
      <PublicCompetitionInfo
        limitDate={auctionInfo[0].data}
        limitTime={auctionInfo[0].hora}
        video={video}
        document={document}
      />
    </section>
  )
}

export default PublicCompetition
